var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordToolTipRt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290,
    height: 100.003,
    viewBox: "0 0 290 100.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435_4",
    x: 0,
    y: 0,
    width: 290,
    height: 100.003,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_17299",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 17299",
    transform: "translate(4.5 3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.5, -3.5)",
    filter: "url(#\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435_4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435_4-2",
    "data-name": "\\u041E\\u0431\\u044A\\u0435\\u0434\\u0438\\u043D\\u0435\\u043D\\u0438\\u0435 4",
    transform: "translate(4.5 3.5)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 254.4210205078125 89.88858032226562 L 249.8445892333984 80.77737426757812 L 249.7061614990234 80.50180053710938 L 249.3977661132812 80.50180053710938 L 0.5000156164169312 80.50180053710938 L 0.5000156164169312 0.5000150799751282 L 280.4998474121094 0.5000150799751282 L 280.4998474121094 80.50180053710938 L 259.4442749023438 80.50180053710938 L 259.1358642578125 80.50180053710938 L 258.9974365234375 80.77737426757812 L 254.4210205078125 89.88858032226562 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 254.4210205078125 88.77465057373047 L 258.8274841308594 80.00180053710938 L 279.9998474121094 80.00180053710938 L 279.9998474121094 1.000015139579773 L 1.000015616416931 1.000015139579773 L 1.000015616416931 80.00180053710938 L 250.0145568847656 80.00180053710938 L 254.4210205078125 88.77465057373047 M 254.4210205078125 91.00258636474609 L 249.3977661132812 81.00180053710938 L 1.559012343932409e-05 81.00180053710938 L 1.559012343932409e-05 1.509748199168826e-05 L 280.9998474121094 1.509748199168826e-05 L 280.9998474121094 81.00180053710938 L 259.4442749023438 81.00180053710938 L 254.4210205078125 91.00258636474609 Z",
    stroke: "none",
    fill: "#038de3"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Set_Your_New_Password:_Complete_required_fields_to_continue.",
    "data-name": "Set Your New Password: Complete required fields to continue.",
    transform: "translate(16 16)",
    fill: "#1d1d1f",
    fontSize: 16,
    fontFamily: "TitilliumWeb-SemiBold, Titillium Web",
    letterSpacing: "0.001em",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "Set Your New Password:")), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "TitilliumWeb-Regular, Titillium Web",
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "Complete required fields to continue."))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordToolTipRt);
export default __webpack_public_path__ + "static/media/passwordToolTipRt.dca699c1896d54650c6c06f8aa811ca9.svg";
export { ForwardRef as ReactComponent };